import { Expose, Type } from 'class-transformer';
import { LocationModel } from '../../customers/models/location.model';
import { Model } from '@shared/models/model';
import { ShipmentRequestLocationType, ShipmentRequestStatus } from '../../shared-features/enums/shipments.enum';
import { Trailer } from '../../fleets/models/trailer.model';
import { ShipmentRequestLabel } from './shipment-request-label.model';
import { User } from '../../users/models/user.model';

export class ShipmentRequest extends Model {
  @Expose() id: number;
  @Expose() status: ShipmentRequestStatus;
  @Type(() => Trailer)
  @Expose()
  trailer: Trailer;
  @Expose() notes: string;
  @Type(() => LocationModel)
  @Expose()
  fromLocation?: LocationModel;
  @Type(() => LocationModel)
  @Expose()
  toLocation?: LocationModel;
  @Expose() fromType: ShipmentRequestLocationType;
  @Expose() toType?: ShipmentRequestLocationType;
  @Expose() label?: ShipmentRequestLabel[] = [];
  @Expose() arrivedPickUpLocation: number;
  @Expose() leavePickUpLocation: number;
  @Expose() arrivedDropLocation: number;
  @Expose() leaveDropLocation: number;

  @Type(() => User)
  @Expose()
  dropOffUser: User = new User();

  constructor() {
    super();
  }
}
